import e from "react";
import { getIconColor as l } from "./iconfont.es5470.js";
import s from "./iconfont.es5471.js";
const i = {
  display: "block"
}, h = ({ size: t = 16, useVw: o, useRem: r, color: a, withColor: n, removeClassName: f, disableSSR: m, style: c, ...d }) => {
  const p = c ? { ...i, ...c } : i;
  return /* @__PURE__ */ e.createElement(s, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "icon-12px-Hot-daohangtiao-fill", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 12 12", width: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (r ? "rem" : "px"), height: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (r ? "rem" : "px"), className: f ? "" : "iconpark-icon", style: p, fill: "none", ...d }, /* @__PURE__ */ e.createElement(
    "g",
    {
      clipPath: "url(#12589f__a)"
    },
    /* @__PURE__ */ e.createElement(
      "mask",
      {
        id: "12589f__b",
        style: { maskType: "luminance" },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "12",
        height: "13"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M0 .017h12v12H0v-12Z",
          fill: n ? l(a, 0, "#fff") : "#fff"
        }
      )
    ),
    /* @__PURE__ */ e.createElement(
      "g",
      {
        mask: "url(#12589f__b)"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M4.815.34c-.185.6-.686 1.68-2.044 3.112-2.355 2.474-2.666 6.46.945 8.42a.56.56 0 0 0 .73-.138c.615-.656.882-1.617.802-2.884-.022-.35.13-.44.432-.202.858.677 1.417 1.716 1.417 2.841 0 .382.15.583.497.515 2.304-.458 5.11-3.828 2.086-8.765-.182-.25-.446-.25-.446.093.006.424-.042.847-.14 1.258-.07.286-.335.283-.395 0C8.322 2.873 7.274 1.415 5.554.216c-.463-.325-.632-.229-.739.124Z",
          fill: n ? l(a, 1, "currentColor") : "currentColor",
          datafollowfill: n ? l(a, 1, "currentColor") : "currentColor"
        }
      )
    )
  ), /* @__PURE__ */ e.createElement(
    "defs",
    null
  ), /* @__PURE__ */ e.createElement(
    "clipPath",
    {
      id: "12589f__a"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M0 0h12v12H0z",
        fill: n ? l(a, 2, "#fff") : "#fff"
      }
    )
  )));
}, x = h;
export {
  x as default
};
